import React from 'react';
import {
  Box,
  Collapse,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  IconButton,
  Typography,
  Chip,
} from '@mui/material';
import { KeyboardArrowDown, KeyboardArrowRight } from '@mui/icons-material';
import { format } from 'date-fns';
import Iconify from '../../../../components/iconify';
import { EmployeeRow, EmployeeTableCell, HeaderSubTitle } from './styles/plannedVsActualReportStyles';
import { UsersForTask } from './UsersForTask';
import { formatSecondesToHourMinute } from '../../../../utils/formatTime';
import { StatusChip } from './StatusChip';
import { TaskDetails } from './TaskDetails';

export const TaskView = ({ project, projectIndex, isExpanded, expandedTasks, onToggleTask, startDate, endDate }) => (
  <TableRow>
    <TableCell style={{ padding: 0 }} colSpan={6}>
      <Collapse in={isExpanded}>
        <Box sx={{ pl: 6 }}>
          <Table size="small" sx={{ tableLayout: 'fixed' }}>
            <TableHead>
              <TableRow>
                <TableCell sx={{ width: '50px' }} />
                <TableCell sx={{ width: '30%' }}>Task Name</TableCell>
                <TableCell sx={{ width: '10%' }} align="right">
                  Status
                </TableCell>
                <TableCell sx={{ width: '10%' }} align="right">
                  Progress
                </TableCell>
                <TableCell sx={{ width: '25%' }} align="right">
                  Consumed Efforts
                  {startDate && endDate && (
                    <HeaderSubTitle>
                      {format(new Date(startDate), 'dd-MM-yyyy')} to {format(new Date(endDate), 'dd-MM-yyyy')}
                    </HeaderSubTitle>
                  )}
                </TableCell>
                <TableCell sx={{ width: '25%' }} align="right">
                  Planned Efforts
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {project.tasks.map((task) => (
                <React.Fragment key={task.id}>
                  <EmployeeRow>
                    <TableCell sx={{ pl: 1 }}>
                      {/* <IconButton size="small" onClick={() => onToggleTask(task.id)}>
                        {expandedTasks.has(task.id) ? <KeyboardArrowDown /> : <KeyboardArrowRight />}
                      </IconButton> */}
                    </TableCell>
                    <EmployeeTableCell>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Iconify icon="material-symbols:task-rounded" />
                        <Typography noWrap>{task.taskName}</Typography>
                        <StatusChip
                          status={task.users?.length || 0}
                          type="count"
                          label={`${task.users.length} employees`}
                        />
                      </Box>
                    </EmployeeTableCell>
                    <EmployeeTableCell>
                      <StatusChip status={task.status} type="status" />
                    </EmployeeTableCell>
                    <EmployeeTableCell align="right">
                      <StatusChip
                        status={Math.round((task.consumedSeconds / task.plannedSeconds) * 100) || 0}
                        type="progress"
                      />
                    </EmployeeTableCell>
                    <EmployeeTableCell align="right">
                      {formatSecondesToHourMinute(task.consumedSeconds)}
                    </EmployeeTableCell>
                    <EmployeeTableCell align="right">
                      {formatSecondesToHourMinute(task.plannedSeconds)}
                    </EmployeeTableCell>
                  </EmployeeRow>
                  {/* {expandedTasks.has(task.id) && <UsersForTask task={task} />} */}
                </React.Fragment>
              ))}
            </TableBody>
          </Table>
        </Box>
      </Collapse>
    </TableCell>
  </TableRow>
);
